<template>
  <div class="c-worklog-card">
    <div class="c-worklog-card__header">
      <div class="c-worklog-card__title">工作日志</div>
      <div>
        <a-button type="primary" @click="gotWorkLog('list')">历史日志</a-button>
        <a-button type="primary" @click="gotWorkLog('add')">写日志</a-button>
      </div>
    </div>
    <div class="c-worklog-card__content">
      <div class="c-worklog-card__date__warp">
        <div class="c-worklog-card__date__row">
          <div
            v-for="(dateText, index) in dateTextList"
            :key="index"
            class="c-worklog-card__date__text"
          >
            <div class="c-worklog-card__date__cell__content">
              {{ dateText }}
            </div>
          </div>
        </div>
        <div
          v-for="(dateRow, rowIndex) in dateRowList"
          :key="rowIndex"
          class="c-worklog-card__date__row"
        >
          <div
            v-for="(dateCell, cellIndex) in dateRow"
            :key="cellIndex"
            class="c-worklog-card__date__cell"
            :class="dateCell.disabled ? 'c-worklog-card__date__cell--disabled' : ''"
          >
            <div
              class="c-worklog-card__date__cell__content"
              :class="[
                'c-worklog-card__date__cell__content--' + dateCell.statusText,
                selectInfo.rowIndex === rowIndex && selectInfo.cellIndex === cellIndex ? 'c-worklog-card__date__content--current' : ''
              ]"
            >
              {{ dateCell.date }}
            </div>
          </div>
        </div>
      </div>
      <div class="c-worklog-card__bottom">
        <div class="c-worklog-card__bottom__date">{{ currentMonth }}</div>
        <div class="c-worklog-card__bottom__tip c-worklog-card__bottom__tip--submit">已提交</div>
        <div class="c-worklog-card__bottom__tip">未提交</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import $utils from '@/utils/utils'
export default {
  props: {
    goToPersonalCenter: {
      type: Function,
      default: null
    }
  },
  data() {
    return {
      selectInfo: {
        rowIndex: '',
        cellIndex: ''
      },
      currentMonth: '',
      startTime: '',
      endTime: '',
      dateTextList: ['一', '二', '三', '四', '五', '六', '日'],
      resultDateList: []
    }
  },
  computed: {
    dateRowList() {
      const resultDateList = [].concat(this.resultDateList)
      const resultList = []
      while (resultDateList.length) {
        resultList.push(resultDateList.splice(0, 7))
      }
      return resultList
    }
  },
  created() {
    this.calcDate()
  },
  methods: {
    ...mapActions('worklog', ['getWorklogSubmitTime']),
    calcDate() {
      // 周一是开头 周日是结束 一行放7天
      const date = new Date()
      date.setHours(0, 0, 0, 0)
      const todayTimestamp = date.getTime()
      // 当月第一天
      date.setDate(1)
      this.currentMonth = $utils.formatDate(date, 'yyyy年MM月')
      this.startTime = date.getTime()
      // 第一天是周几
      const monthFirstDay = date.getDay()
      // 如果周日就是第一行最后一个向前找六天
      const beforeDayCount = monthFirstDay === 0 ? 6 : monthFirstDay - 1
      const monthFirstDayTimestamp = date.getTime()
      // 当月最后一天
      date.setMonth(date.getMonth() + 1, 0)
      const monthLastDate = date.getDate()
      const monthLastDay = date.getDay()
      // 如果是周日就是最后一行最后一个
      const afterDayCount = monthLastDay === 0 ? 0 : 8 - monthLastDay
      const monthLastDayTimestamp = date.getTime()

      const oneDayTimestamp = 86400000
      const resultDateList = []
      // 先补上个月的
      for (let index = beforeDayCount; index > 0; index--) {
        const diffTimestamp = oneDayTimestamp * index
        resultDateList.push(this.generateDateItem(monthFirstDayTimestamp - diffTimestamp, true))
      }
      // 放当月的
      for (let index = 0; index < monthLastDate; index++) {
        const diffTimestamp = oneDayTimestamp * index
        resultDateList.push(this.generateDateItem(monthFirstDayTimestamp + diffTimestamp))
      }
      // 放下一个月补充
      for (let index = 1; index < afterDayCount; index++) {
        const diffTimestamp = oneDayTimestamp * index
        resultDateList.push(this.generateDateItem(monthLastDayTimestamp + diffTimestamp, true))
      }

      const todayIndex = resultDateList.findIndex(item => item.timestamp === todayTimestamp)
      this.selectInfo = {
        rowIndex: Math.floor(todayIndex / 7),
        cellIndex: todayIndex % 7
      }
      for (let index = todayIndex; index >= 0; index--) {
        resultDateList[index].canClick = true
        resultDateList[index].status = 0
        resultDateList[index].statusText = 'todo'
      }
      this.resultDateList = resultDateList

      date.setHours(23, 59, 59, 59)
      this.endTime = date.getTime()
      this.getWorklogBySubmitTime()
    },
    async getWorklogBySubmitTime() {
      const result = await this.getWorklogSubmitTime({
        startTime: this.startTime,
        endTime: this.endTime
      })
      const data = result || {}
      Object.keys(data).forEach(id => {
        const findDate = this.resultDateList.find(item => item.timestamp === data[id])
        if (findDate) {
          findDate.status = 1
          findDate.statusText = 'completed'
          findDate.workLogId = id
        }
      })
    },
    generateDateItem(timestamp, disabled = false) {
      const date = new Date(timestamp)
      return {
        timestamp: date.getTime(),
        date: date.getDate(),
        status: '',
        statusText: 'feature',
        canClick: false,
        workLogId: '',
        disabled
      }
    },
    gotWorkLog(type) {
      const enterPath = type === 'add' ? '/performance-evaluation/worklog-add.html' : '/performance-evaluation/worklog-list.html'
      this.goToPersonalCenter(enterPath)
    }
  }
}
</script>

<style lang="scss">
.c-worklog-card {
  padding: 16px;
  background-color: #fff;
  .c-worklog-card__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    button+button {
      margin-left: 10px;
    }
    .c-worklog-card__title {
      font-size: 16px;
      font-weight: bold;
      color: #333;
    }
  }
  .c-worklog-card__content {
    font-size: 0.14rem;
    box-shadow: 0px 0px 10px rgba(215, 215, 215, 0.3);
  }
  .c-worklog-card__date__warp {
    padding: 16px 16px 32px;
    border-bottom: 2px solid #f2f2f2;
    .c-worklog-card__date__row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .c-worklog-card__date__cell, .c-worklog-card__date__text {
        width: 60px;
        height: 45px;
        display: flex;
        justify-content: center;
        .c-worklog-card__date__cell__content {
          width: 45px;
          height: 45px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .c-worklog-card__date__cell__content--todo {
          color: rgb(245 154 35);
        }
        .c-worklog-card__date__cell__content--completed {
          color: rgb(0, 82, 217);
        }
      }
      .c-worklog-card__date__cell--disabled {
        cursor: not-allowed;
        .c-worklog-card__date__cell__content {
          color: rgba(0, 0, 0, 0.26) !important;
        }
      }
      .c-worklog-card__date__content--current {
        background: rgba(24, 144, 255, 0.1);
      }
    }
  }
  .c-worklog-card__bottom {
    display: flex;
    align-items: center;
    padding: 24px 32px;
    .c-worklog-card__bottom__date {
      margin-right: 20px;
    }
    .c-worklog-card__bottom__tip {
      margin-left: 20px;
      display: flex;
      align-items: center;
    }
    .c-worklog-card__bottom__tip::before {
      content: '';
      width: 18px;
      height: 18px;
      border-radius: 2px;
      margin-right: 10px;
      background-color: rgb(245 154 35);
      display: block;
    }
    .c-worklog-card__bottom__tip--submit::before {
      background-color: rgb(0, 82, 217);
    }
  }
}
</style>
